<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-12">
        <div class="overview-wrap">
          <h2 class="title-1">Нийтлэл үүсгэх</h2>
        </div>
      </div>
    </div>

    <div class="row my-3">
      <div class="card w-100">
        <div class="card-header">
          <div class="row form-group">
            <div class="col col-md-1">
              <label for="text-input" class="form-control-label">Нэр*</label>
            </div>
            <div class="col-12 col-md-4">
              <input
                type="text"
                id="text-input"
                name="text-input"
                class="form-control"
                v-on:input="onChangeHandler('name', $v.name)"
                :class="{ 'form-control is-invalid': $v.name.$error }"
                v-model="name"
              >
              <div class="invalid-feedback">{{ this.getErrorMsg('name')[0] }}</div>
            </div>

            <div class="col col-md-1 offset-1">
              <label for="text-input" class="form-control-label">Огноо*</label>
            </div>
            <div class="col-12 col-md-5">
              <input
                class="form-control"
                type="date"
                v-on:input="onChangeHandler('publishDate', $v.publishdate)"
                :class="{ 'is-invalid': $v.publishdate.$error }"
                v-model="publishdate"
              >
              <div class="invalid-feedback">{{ this.getErrorMsg('publishDate')[0] }}</div>
            </div>
          </div>
        </div>
        <div class="card-body">
          <div class="default-tab">
            <div class="d-flex">
              <div
                :class="[{ 'tab--selected' : languageTab === 'MN', 'tab--invalid': mnTabError && languageTab !== 'MN' }, 'nav-link tab']"
                @click="languageTab = 'MN'"
              >MON</div>
              <div
                :class="[{ 'tab--selected' : languageTab === 'EN', 'tab--invalid': enTabError && languageTab !== 'EN' }, 'nav-link tab']"
                @click="languageTab = 'EN'"
              >ENG</div>
            </div>

            <br>
            <!-- MN tab -->
            <div v-if="languageTab === 'MN'">
              <div class="row form-group">
                <div class="col-3">
                  <label class="form-control-label">Гарчиг*</label>
                </div>
                <div class="col-9">
                  <input
                    type="text"
                    id="text-input"
                    name="text-input"
                    class="form-control"
                    v-on:input="onChangeHandler('title.0', $v.mntitle)"
                    :class="{ 'is-invalid': $v.mntitle.$error }"
                    v-model="mntitle"
                  >
                  <div class="invalid-feedback">{{ this.getErrorMsg('title.0')[0] }}</div>
                </div>
              </div>
              <div class="row form-group">
                <div class="col-3">
                  <label class="form-control-label">Тайлбар*</label>
                </div>
                <div class="col-9">
                  <textarea-autosize
                    class="form-control"
                    v-on:input="onChangeHandler('description.0', $v.mndesc)"
                    :class="{ 'is-invalid': $v.mndesc.$error }"
                    v-model="mndesc"
                  ></textarea-autosize>
                  <div class="invalid-feedback">{{ this.getErrorMsg('description.0')[0] }}</div>
                </div>
              </div>
              <div class="row form-group">
                <div class="col-3">
                  <label for="text-input" class="form-control-label">Зураг (thumb) 330x200</label>
                </div>
                <div class="col-9">
                  <div class="custom-file">
                    <input
                      type="file"
                      accept="image/*"
                      class="custom-file-input"
                      id="inputGroupFile01"
                      aria-describedby="inputGroupFileAddon01"
                      @change="onThumbInput($event, true)"
                    >
                    <label class="custom-file-label" for="inputGroupFile01">Файл сонгох</label>
                  </div>
                  <img class="thumb-image mt-4" v-if="mnthumb !== ''" v-bind:src="mnthumb" alt>
                </div>
              </div>
              <div id="summernote">
                <quill-editor
                  v-model="mnEditorContent"
                  ref="mnEditor"
                  :options="editorOption"
                  @change="onChangeHandler('body.0', $v.mnEditorContent)"
                ></quill-editor>
                <div v-if="$v.mnEditorContent.$error" class="text-danger">
                  <small>{{ this.getErrorMsg('body.0')[0] }}</small>
                </div>
              </div>
            </div>

            <!-- EN tab -->
            <div v-else-if="languageTab === 'EN'">
              <div class="row form-group">
                <div class="col-3">
                  <label class="form-control-label">{{ enTitle }}</label>
                </div>
                <div class="col-9">
                  <input
                    type="text"
                    id="text-input"
                    name="text-input"
                    class="form-control"
                    v-on:input="onChangeHandler('title.1', $v.entitle)"
                    :class="{ 'is-invalid': $v.entitle.$error }"
                    v-model="entitle"
                  >
                  <div class="invalid-feedback">{{ this.getErrorMsg('title.1')[0] }}</div>
                </div>
              </div>
              <div class="row form-group">
                <div class="col-3">
                  <label class="form-control-label">{{ enDesc }}</label>
                </div>
                <div class="col-9">
                  <textarea-autosize
                    class="form-control"
                    v-on:input="onChangeHandler('description.1', $v.endesc)"
                    :class="{ 'is-invalid': $v.endesc.$error }"
                    v-model="endesc"
                  ></textarea-autosize>
                  <div class="invalid-feedback">{{ this.getErrorMsg('description.1')[0] }}</div>
                </div>
              </div>
              <div class="row form-group">
                <div class="col-3">
                  <label for="text-input" class="form-control-label">Зураг (thumb)</label>
                </div>
                <div class="col-9">
                  <div class="custom-file">
                    <input
                      type="file"
                      accept="image/*"
                      class="custom-file-input"
                      id="inputGroupFile01"
                      aria-describedby="inputGroupFileAddon01"
                      @change="onThumbInput($event, false)"
                    >
                    <label class="custom-file-label" for="inputGroupFile01">Файл сонгох</label>
                  </div>
                  <img class="thumb-image mt-4" v-if="enthumb !== ''" v-bind:src="enthumb" alt>
                </div>
              </div>
              <div id="summernote">
                <quill-editor
                  v-model="enEditorContent"
                  ref="enEditor"
                  :options="editorOption"
                  @change="onChangeHandler('body.1', $v.enEditorContent)"
                ></quill-editor>
                <div v-if="$v.enEditorContent.$error" class="text-danger">
                  <small>{{ this.getErrorMsg('body.1')[0] }}</small>
                </div>
              </div>
            </div>
          </div>
          <input
            type="file"
            accept="image/*"
            id="editor-image"
            @change="onEditorInput($event)"
            hidden
          >
        </div>
        <div class="card-footer d-flex justify-content-end">
          <button @click="$parent.goBack()" type="submit" class="btn btn-primary mx-2">Буцах</button>
          <button @click="onSubmit" type="submit" class="btn btn-success">
            <i class="fa fa-dot-circle"></i> Хадгалах
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<style>
.thumb-image {
  max-width: 250px;
  max-height: 250px;
}
</style>

<script>
import MenuService from "@/services/MenuService";
import Form from "@/mixins/Form.js";
import ImageUploadService from "@/services/ImageUploadService";

export default {
  name: "ArticleCreate",

  mixins: [Form],

  props: ["parentId"],

  computed: {
    mnTabError() {
      return this.$v.mntitle.$error || this.$v.mndesc.$error;
    },

    enTabError() {
      return this.$v.entitle.$error || this.$v.endesc.$error;
    },

    enTitle() {
      return this.hasEngdata() ? "Гарчиг*" : "Гарчиг";
    },

    enDesc() {
      return this.hasEngdata() ? "Тайлбар*" : "Тайлбар";
    }
  },

  data() {
    return {
      name: "",
      publishdate: new Date().toISOString().split("T")[0],
      mntitle: "",
      entitle: "",
      mndesc: "",
      endesc: "",
      mnthumb: "",
      enthumb: "",
      mnEditorContent: "",
      enEditorContent: "",

      editorOption: {
        modules: {
          imageResize: true,
          videoResize: {
            modules: ["Resize"]
          },
          toolbar: {
            container: [
              [{ size: ["small", false, "large"] }],
              ["bold", "italic", "underline"],
              [{ script: "sub" }, { script: "super" }],
              [{ direction: "rtl" }],
              [{ list: "ordered" }, { list: "bullet" }],
              [{ color: [] }, { background: [] }],
              [{ align: [] }],
              ["link", "image", "video"],
              ["clean"],
              ["clearformat"]
            ],
            handlers: {
              image: function() {
                document.getElementById("editor-image").click();
              },
              clearformat: function() {
                var range = this.quill.getSelection();
                if (range) {
                  this.quill.formatText(range, "clearformat", true);
                }
              }
            }
          }
        },
        theme: "snow"
      }
    };
  },

  validations: {
    name: {
      serverFailed: function() {
        return !this.hasServerError("name");
      }
    },
    publishdate: {
      serverFailed: function() {
        return !this.hasServerError("publishDate");
      }
    },
    mntitle: {
      serverFailed: function() {
        return !this.hasServerError("title.0");
      }
    },
    entitle: {
      serverFailed: function() {
        return !this.hasServerError("title.1");
      }
    },
    mndesc: {
      serverFailed: function() {
        return !this.hasServerError("description.0");
      }
    },
    endesc: {
      serverFailed: function() {
        return !this.hasServerError("description.1");
      }
    },
    mnEditorContent: {
      serverFailed: function() {
        return !this.hasServerError("body.0");
      }
    },
    enEditorContent: {
      serverFailed: function() {
        return !this.hasServerError("body.1");
      }
    }
  },

  methods: {
    serverRequest: MenuService.createArticle,

    successHandler(response) {
      if (response.data.payload.toast != null)
        this.showToast(response.data.payload.toast);

      this.$router.push("/submenu/" + this.parentId);
    },

    createJsonData() {
      let data = JSON.parse("{}");
      data.parentId = this.$route.params.parentId;
      data.name = this.name;
      data.publishDate = this.publishdate;
      data.contents = [];

      let mncontent = JSON.parse("{}");
      mncontent.language = 1;
      mncontent.title = this.mntitle;
      mncontent.description = this.mndesc;
      if (this.mnthumb != "") mncontent.thumb = this.mnthumb;
      mncontent.body = this.mnEditorContent;
      data.contents.push(mncontent);

      if (this.hasEngdata()) {
        let encontent = JSON.parse("{}");
        encontent.language = 2;
        encontent.title = this.entitle;
        encontent.description = this.endesc;
        if (this.enthumb != "") encontent.thumb = this.enthumb;
        encontent.body = this.enEditorContent;
        data.contents.push(encontent);
      }
      return data;
    },

    hasEngdata() {
      return (
        this.entitle != "" ||
        this.endesc != "" ||
        this.enthumb != "" ||
        this.enEditorContent != ""
      );
    },

    onThumbInput(event, isMon) {
      if (event.target.files[0] != null) {
        const data = new FormData();
        data.append("image", event.target.files[0]);
        ImageUploadService.uploadImage(data).then(response => {
          if (isMon) this.mnthumb = response.data;
          else this.enthumb = response.data;
        });
      }
    },

    onEditorInput(event) {
      const data = new FormData();
      data.append("image", event.target.files[0]);
      event.target.value = "";
      ImageUploadService.uploadImage(data).then(response => {
        if (this.languageTab == "MN")
          this.$refs.mnEditor.quill.insertEmbed(
            this.$refs.mnEditor.quill.getSelection().index,
            "image",
            response.data
          );
        else if (this.languageTab == "EN")
          this.$refs.enEditor.quill.insertEmbed(
            this.$refs.enEditor.quill.getSelection().index,
            "image",
            response.data
          );
      });
    }
  }
};
</script>